import { FC } from 'react'
import { icon, ruleState } from './styles.css'
import { CheckCircle, Info } from 'lucide-react'
import { trueOrUndefined } from '@genie-fintech/ui/functions'

type Props = {
  label: string
  isPass: boolean
}

const PasswordRules: FC<Props> = ({ label, isPass }) => {
  const Icon = isPass ? CheckCircle : Info
  return (
    <article className={ruleState} data-pass={trueOrUndefined(isPass)}>
      <Icon size={20} className={icon} />
      {label}
    </article>
  )
}

export default PasswordRules
